import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-up",
  "use": "icon-nav-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-nav-up\"><path d=\"M11.4 6.4 8 3 4.6 6.4l.8.7 2.1-2.2V13h1V4.9l2.1 2.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol